import { useState } from 'react';
import { MdFileDownload } from 'react-icons/md';
import { Button, Modal, Spinner } from 'react-bootstrap';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { saveAs } from 'file-saver';
import { Media } from '@website/types/graphqlOperations';
import { composeImageURL } from '../utils/imgix';

type Props = {
  photos: Pick<Media, 'file' | 'id'>[];
};

export default function GuestMediaDownloadAll({ photos }: Props) {
  // Download modal state
  const [showDownloadingModal, setShowDownloadingModal] = useState(false);

  // Promisify JSZipUtils.getBinaryContent (download the image)
  function urlToPromise(url: string): any {
    return new Promise((resolve, reject) => {
      JSZipUtils.getBinaryContent(url, (err, data) => {
        if (err) {
          reject(err);
        } else {
          resolve(data);
        }
      });
    });
  }

  // Onclick handler
  function onClickDownloadAll() {
    const zip = new JSZip();
    const imageFiles = zip.folder('images');

    photos.forEach((image, key) => {
      const url = composeImageURL(image.file?.key, {
        fm: 'jpg',
        q: '90',
        dl: image.file.key,
      });
      imageFiles.file(`${key}.jpg`, urlToPromise(url), { binary: true });
    });

    setShowDownloadingModal(true);

    // Generate the zip file asynchronously
    zip.generateAsync({ type: 'blob' }).then((content) => {
      // Force down of the Zip file
      saveAs(content, 'archive.zip');
      setShowDownloadingModal(false);
    });
  }

  return (
    <>
      <div className="d-grid gap-2">
        <Button onClick={() => onClickDownloadAll()}>
          <MdFileDownload /> Download All Photos
        </Button>
      </div>
      <Modal show={showDownloadingModal}>
        <Modal.Header closeButton>
          <Modal.Title>Preparing your download</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Spinner animation="border" size="sm" />
          This may take a few minutes...
        </Modal.Body>
      </Modal>
    </>
  );
}
